/**
 * @generated SignedSource<<4c5a2b5d0fa7aecddf56a5107dcfe438>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ResourceCriteria_resourceTypes$data = {
  readonly resourceCriteriaTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly qualifiedName: string;
      };
    }>;
  };
  readonly " $fragmentType": "ResourceCriteria_resourceTypes";
};
export type ResourceCriteria_resourceTypes$key = {
  readonly " $data"?: ResourceCriteria_resourceTypes$data;
  readonly " $fragmentSpreads": FragmentRefs<"ResourceCriteria_resourceTypes">;
};

import ResourceCriteriaResourceTypesPaginationQuery_graphql from './ResourceCriteriaResourceTypesPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "resourceCriteriaTypes"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [],
      "operation": ResourceCriteriaResourceTypesPaginationQuery_graphql
    }
  },
  "name": "ResourceCriteria_resourceTypes",
  "selections": [
    {
      "alias": "resourceCriteriaTypes",
      "args": [
        {
          "kind": "Variable",
          "name": "filterElement",
          "variableName": "filter"
        }
      ],
      "concreteType": "ResourceTypeConnection",
      "kind": "LinkedField",
      "name": "__ResourceCriteria__resourceCriteriaTypes_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ResourceTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ResourceType",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "qualifiedName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "530a21cf454a5d77c01b1716c3214694";

export default node;
